/**
 * 商户数据模型（核心逻辑层）
 */
import { services } from '../services';

export const BusinessModel = {
  /**
   * 获取筛选后的商户列表（调用接口+校验+分组）
   * @param {Object} params 筛选参数
   * @param {string} params.category 分类ID（必传）
   * @param {string} [params.search] 搜索关键词
   * @param {Array} [params.regions] 区域列表
   * @returns {Promise<Object>} 按区域分组的商户数据
   */
  getFilteredBusinesses: async (params) => {
    // 1. 入参校验（业务逻辑）
    if (!params?.categoryId) throw new Error('商户查询缺少必传参数：categoryId');

    // 2. 构造接口参数（格式化参数）
    // const apiParams = {
    //   category: params.category,
    //   search: params.search?.trim() || ''
    // };
    // if (Array.isArray(params.regions) && params.regions.length > 0) {
    //   apiParams.regions = params.regions.join(','); // 区域数组转拼接字符串
    // }

    // 3. 调用 Services 层接口
    const response = await services.business.getBusinesses(params);
    if (!response.ok) throw new Error('商户接口请求失败');
    const rawData = await response.json();
    console.log("-----商户列表----》",rawData)
    return rawData?.result;
    // 4. 数据校验+格式化
    // const validData = BusinessModel._validateList(rawData);

    // 5. 业务处理：按区域分组（页面所需格式）
    // const groupedData = BusinessModel._groupByRegion(rawData);


    // return rawData?.slice((params.page - 1) * params.pageSize, params.page * params.pageSize);
  },
  /**
   * 获取某个商户的信息（调用接口）
   * @param {Object} params 筛选参数
   * @param {string} params.id ID（必传）
   * @returns {Promise<Object>} 商户数据
   */
  getDetail: async (params) => {
    // 1. 入参校验（业务逻辑）
    if (!params?.id) throw new Error('商户查询缺少必传参数：id');

    // 2. 构造接口参数（格式化参数）
    const apiParams = {
      id: params.id,
    };

    // 3. 调用 Services 层接口
    const response = await services.business.getDetail(apiParams);
    if (!response.ok) throw new Error('商户接口请求失败');
    const data = await response.json();

    // const data = await services.business.getDetail(apiParams);

    return data;
  },

  /**
   * 私有方法：校验商户列表
   */
  _validateList: (rawList) => {
    if (!Array.isArray(rawList)) throw new Error('商户接口返回格式错误（非数组）');
    return rawList.map(item => {
      if (!item?.id) throw new Error('商户缺少必填字段：id');
      if (!item?.name) throw new Error(`商户ID:${item.id} 缺少名称`);
      if (!item?.mainImage) throw new Error(`商户ID:${item.id} 缺少主图`);
      if (!item?.address) throw new Error(`商户ID:${item.id} 缺少地址`);
      if (!item?.region) throw new Error(`商户ID:${item.id} 缺少区域`);
    //   if (isNaN(Number(item.latitude))) throw new Error(`商户ID:${item.id} 纬度格式错误`);
    //   if (isNaN(Number(item.longitude))) throw new Error(`商户ID:${item.id} 经度格式错误`);
      // 格式化字段
      return {
        id: String(item.id),
        name: item.name.trim(),
        mainImage: item.mainImage.trim(),
        address: item.address.trim(),
        region: item.region.trim(),
        latitude: Number(item.latitude),
        longitude: Number(item.longitude)
      };
    });
  },

  /**
   * 私有方法：商户列表按区域分组
   */
  _groupByRegion: (validList) => {
    return validList.reduce((acc, business) => {
      const region = business.region || '未分类';
      if (!acc[region]) acc[region] = [];
      acc[region].push(business);
      return acc;
    }, {});
  }
};